<template>
  <div style="display: flex; flex-direction: row;">
    <div style=" display: flex; flex-direction: row;">
      {{label}}<div style="display: inline-block;">:</div>
    </div>
    <input
      class="simple-checkbox"
      style="margin: .3rem .5rem;"
      type="checkbox"
      v-model="checked"
      :identifier="`${identifier}-checkbox`"
      @change="handleInput">
  </div>
</template>

<script>
export default {
  name: 'FormCheckboxInput',
  props: ['value', 'identifier', 'label', 'changeFunction'],
  data () {
    return {
      checked: undefined,
    }
  },
  methods: {
    handleInput (newVal) {
      this.$emit('change', this.checked)
    },
  },
  mounted () {
    this.checked = this.value
  },
}
</script>

<style>

</style>
